var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsidePool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.82812C11 9.82812 10.998 8.5 9.83728 8.5C8.58728 8.5 8.5 9.5 8.5 10.0833V17",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.82812C16.5 9.82812 16.498 8.5 15.3373 8.5C14.0873 8.5 14 9.5 14 10.0833V17",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5H14M8.5 15H14",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17L3.39547 17.3633C3.8002 17.735 4.40919 17.7749 4.8589 17.459V17.459C5.25297 17.1822 5.77642 17.1752 6.17771 17.4414L6.28696 17.5139C6.73299 17.8098 7.31101 17.8169 7.7642 17.5321L7.91236 17.439C8.33327 17.1744 8.87356 17.1961 9.27198 17.4934V17.4934C9.6791 17.7973 10.2332 17.8126 10.6565 17.5318L10.7464 17.4721C11.1814 17.1836 11.7433 17.1703 12.1914 17.4378L12.3878 17.5551C12.8432 17.827 13.4143 17.8134 13.8563 17.5202L13.9155 17.4809C14.3527 17.1909 14.9229 17.1985 15.3522 17.5V17.5C15.7815 17.8015 16.3517 17.8091 16.7889 17.5191L16.9118 17.4376C17.3116 17.1724 17.8313 17.1724 18.231 17.4376V17.4376C18.7195 17.7616 19.371 17.6828 19.7681 17.2517L20 17",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5L3.39547 19.8633C3.8002 20.235 4.40919 20.2749 4.8589 19.959V19.959C5.25297 19.6822 5.77642 19.6752 6.17771 19.9414L6.28696 20.0139C6.73299 20.3098 7.31101 20.3169 7.7642 20.0321L7.91236 19.939C8.33327 19.6744 8.87356 19.6961 9.27198 19.9934V19.9934C9.6791 20.2973 10.2332 20.3126 10.6565 20.0318L10.7464 19.9721C11.1814 19.6836 11.7433 19.6703 12.1914 19.9378L12.3878 20.0551C12.8432 20.327 13.4143 20.3134 13.8563 20.0202L13.9155 19.9809C14.3527 19.6909 14.9229 19.6985 15.3522 20V20C15.7815 20.3015 16.3517 20.3091 16.7889 20.0191L16.9118 19.9376C17.3116 19.6724 17.8313 19.6724 18.231 19.9376V19.9376C18.7195 20.2616 19.371 20.1828 19.7681 19.7517L20 19.5",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.5L10.8466 4.31414C11.5381 3.82606 12.4619 3.82606 13.1534 4.31414L20.5 9.5",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsidePool);
export default __webpack_public_path__ + "static/media/inside_pool.7208dded9b81f2de37b2c8171afe0ef6.svg";
export { ForwardRef as ReactComponent };